<template>
  <div>
    <div class="searchDiv">
      <el-select class="searchInput" v-model="params.type" placeholder="请选择类型" clearable>
        <el-option v-for="item in $dict.map['template_type']" :key="item.value" :label="item.name"
                   :value="item.value"></el-option>
      </el-select>
      <el-input class="searchInput" v-model="params.filename" placeholder="请输入文件名称" clearable @clear="getPageList"
                @keyup.enter.native="getPageList"/>
      <el-button type="primary" @click="getPageList">查询</el-button>
      <el-button v-if="hasPer('template:add')" @click="editRow" style="float: right;">新增</el-button>
    </div>
    <el-table :data="tableData" row-key="id" border>
      <el-table-column label="类型" prop="type" width="250px">
        <template slot-scope="scope">
          <el-tag type="success">{{$dict.nameOf('template_type', scope.row.type)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="文件" prop="path">
        <template slot-scope="scope">
          <el-link v-if="scope.row.path" type="primary" :href="scope.row.path" target="_blank" @click="downloadFile(scope.row.path, scope.row.filename)">
            {{ scope.row.filename }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime"></el-table-column>
      <el-table-column label="创建人" prop="creator"></el-table-column>
      <el-table-column label="操作" prop="option" width="220px" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasPer('template:edit')" type="primary" @click="editRow(JSON.parse(JSON.stringify(scope.row)))">
            编辑
          </el-button>
          <el-button v-if="hasPer('template:del')" type="danger" @click="delRow(scope.row.id, $dict.nameOf('template_type', scope.row.type))">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination :current.sync="current" :size.sync="size" :total="total" @get-list="getPageList"></pagination>
    <edit-template :dialog-visible.sync="dialogVisible" :data-obj="rowDataObj" @get-list="getPageList"></edit-template>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import {delTemplate, getTemplatePage} from "@/api/template/template"; // 修改API导入
import {infoMsg, successMsg} from "@/utils/message";
import {hasPer} from "@/utils/common";
import store from "@/store";
import EditTemplate from "@/views/template/editTemplate.vue"; // 修改组件导入

export default {
  name: "flow",
  components: {
    EditTemplate,
    Pagination
  },
  data() {
    return {
      params: {
        type: '',
        filename: ''
      },
      username: store.state.userInfo.username,
      tableData: [],
      dialogVisible: false,
      rowDataObj: {},
      current: 1,
      size: 10,
      total: 0
    }
  },
  mounted() {
    this.getPageList();
  },
  methods: {
    hasPer,
    getPageList() {
      getTemplatePage({...this.params}).then(res => { // 修改API调用
        this.tableData = res.records
        this.total = res.total
      })
    },
    editRow(row) {
      this.dialogVisible = true
      this.rowDataObj = row.id ? row : {}
    },
    delRow(id, name) {
      this.$confirm('确定删除类型【' + name + '】的合同文件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delTemplate(id).then(() => { // 修改API调用
          successMsg('操作成功')
          this.getPageList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    },
    downloadFile(path, filename) {
      const link = document.createElement('a');
      link.href = path;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  }
}
</script>

<style scoped>

</style>
